var React = require('react');

function Windows (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.5 32.615 5 30.91v-9.547h12.5v11.252zm2.5.34L35 35V21.363H20v11.592zm0-14.317h15V5L20 7.045v11.592zm-2.5-11.25L5 9.09v9.547h12.5V7.387z","fill":"#fff"}));
}

Windows.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Windows;

Windows.default = Windows;
